import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import './App.css';

import Home from "./Pages/Home";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Blog from "./Pages/Blog";
import Services from "./Pages/Services";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import CTA from "./Components/CTA";
import HighSpeedDoubleRotary from "./Pages/HIGH_SPEED_DOUBLE_ESIDE_ROTARY_TABLET_PRESS";
import DoubleSideRotary from "./Pages/Double_Side_Rotary_Tableting_Machine";
import SingleRotaryTabletPress from "./Pages/SINGLE_SIDE_ROTARY_TABLET_PRESS";
import SingleRotaryNonGMP from "./Pages/Single_Rotary_Tablet_Press_non";
import MiniRotaryTabletPress from "./Pages/MiniRotaryTabletPress";
import FluidBedDryer from "./Pages/FluidBedDryer";
import RapidMixerGranulator from "./Pages/RapidMixerGranulator";
import RollCompactorMachine from "./Pages/RollCompactorMachine";
import ColloidMillMachine from "./Pages/ColloidMillMachine";
import MassMixerMachine from "./Pages/MassMixerMachine";
import DeBurringDeDustingMachine from "./Pages/DeBurringDeDustingMachine";
import CoatingMachine from "./Pages/CoatingMachine";
import OscillatingGranulator from "./Pages/OscillatingGranulator";
import VibroSifterMachine from "./Pages/VibroSifterMachine";
import MultiMillMachine from "./Pages/MultiMillMachine";
import DustExtractorMachine from "./Pages/DustExtractorMachine";
import Tab2000 from "./Pages/Tab2000";



function App() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "assets/js/main.js";
    script.async = true;
    document.body.appendChild(script);
    // Prevent appear.js errors by wrapping in try-catch

    return () => {
        document.body.removeChild(script);
    };
  }, []);

  // ✅ Check if current page is homepage
  const isHome = window.location.pathname === "/";

  return (
    <Router>
      <div className="App">
        <div className="body-overlay"></div>

        <div className="tj-preloader is-loading">
          <div className="tj-preloader-inner">
            <div className="tj-preloader-ball-wrap">
              <div className="tj-preloader-ball-inner-wrap">
                <div className="tj-preloader-ball-inner">
                  <div className="tj-preloader-ball"></div>
                </div>
                <div className="tj-preloader-ball-shadow"></div>
              </div>
              <div id="tj-weave-anim" className="tj-preloader-text">
                Loading...
              </div>
            </div>
          </div>
          <div className="tj-preloader-overlay"></div>
        </div>

        <div id="tj-back-to-top">
          <span id="tj-back-to-top-percentage"></span>
        </div>

        {/* 👇 Header only on non-home pages */}
        {/* {!isHome && <Header />} */}
        <Header />
        <div id="smooth-wrapper">
          <div id="smooth-content">
                    <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/high-speed-double-side-rotary-tablet-press" element={<HighSpeedDoubleRotary />} />
          <Route path="/double-side-rotary-tableting-machine" element={<DoubleSideRotary />} />
          <Route path="/single-rotary-tablet-press" element={<SingleRotaryTabletPress />} />
          <Route path="/single-rotary-tablet-press-non-gmp" element={<SingleRotaryNonGMP />} />
          <Route path="/mini-rotary-tablet-press" element={<MiniRotaryTabletPress />} />
          <Route path="/fluid-bed-dryer" element={<FluidBedDryer />} />
          <Route path="/rapid-mixer-granulator" element={<RapidMixerGranulator />} />
          <Route path="/roll-compactor-machine" element={<RollCompactorMachine />} />
          <Route path="/colloid-mill-machine" element={<ColloidMillMachine />} />
          <Route path="/mass-mixer-machine" element={<MassMixerMachine />} />
          <Route path="/de-burring-de-dusting-machine" element={<DeBurringDeDustingMachine />} />
          <Route path="/coating-machine" element={<CoatingMachine />} />
          <Route path="/oscillating-granulator" element={<OscillatingGranulator />} />
          <Route path="/vibro-sifter-machine" element={<VibroSifterMachine />} />
          <Route path="/multi-mill-machine" element={<MultiMillMachine />} />
          <Route path="/dust-extractor-machine" element={<DustExtractorMachine />} />
          <Route path="/tab-2000" element={<Tab2000 />} />
          </Routes>
            <CTA />
             <Footer />
          </div>
        </div>
      </div>
    </Router>
  );
}

export default App;
